(function () {
    'use strict';
    var controllerId = 'cndAccreditamentoSedeAdd';
    angular.module('app').controller(controllerId, ['$scope', '$rootScope', 'datacontext', 'sectionMenu', '$uibModalInstance', 'cndAccredSede', 'province', 'cndAccreditamentoId', 'progettoId', cndAccreditamentoSedeAdd]);

    function cndAccreditamentoSedeAdd($scope, $rootScope, datacontext, sectionMenu, $uibModalInstance, cndAccredSede, province, cndAccreditamentoId, progettoId) {
        $scope.province = province;
        $scope.comuni = [];

        $scope.getComuni = getComuni;

        if (cndAccredSede) {
            $scope.title = 'Modifica Sede';
            $scope.cndAccreditamentoSede = jQuery.extend({}, cndAccredSede); //Clona oggetto
            //$scope.action = 'Add';
            getComuni($scope.cndAccreditamentoSede.ProvinciaId);
        }
        else {
            $scope.title = 'Nuova Sede';
            $scope.cndAccreditamentoSede = {};
            $scope.cndAccreditamentoSede.Id = 0;
            //$scope.action = 'Edit';
        }

    	//Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
        	$scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
        	$scope.dt = null;
        };

    	// Disable weekend selection
        $scope.disabled = function (date, mode) {
        	return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
        	$scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
        	formatYear: 'yyyy',
        	formatMonth: 'MM',
        	startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
        	$event.preventDefault();
        	$event.stopPropagation();

        	$scope.opened1 = false;
        	if (iOpened == 1)
        		$scope.opened1 = true;
        };

        if (progettoId) {
            $scope.progettoId = progettoId;
        }


        if (cndAccreditamentoId) {
            $scope.cndAccreditamentoId = cndAccreditamentoId;
            $scope.cndAccreditamentoSede.cndAccreditamentoId = cndAccreditamentoId;
        }


        function getComuni(idprov) {
            if (!idprov || idprov == 0) return $scope.comuni = [];

            if ($scope.cndAccreditamentoSede.ProvinciaId != idprov)
                $scope.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.comuni = data;
            });
        }

        $scope.ok = function (isValid) {
            if (isValid) {
                if ($scope.cndAccreditamentoSede.Id == 0) {
                    var result = addItem($scope.cndAccreditamentoSede);
                    $uibModalInstance.close(result);
                }
                else {
                    var result = updateItem($scope.cndAccreditamentoSede);
                    $uibModalInstance.close(result);
                }
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
        	return datacontext.cndAccreditamentoSede_add(item).then(function (data) {
                if (!data) return null;

                return data;
            });
        }

        function updateItem(item) {
            return datacontext.cndAccreditamentoSede_update(item).then(function (data) {
                if (!data) return null;

                return data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-EXISTS cndAccreditamento SEDE -#-#-#-#-#-#
        $scope.existsSede = false;
        $scope.searchSede = function (value) {
            console.log('searchSede()');
            $scope.existsSede = false;
            return datacontext.cndAccreditamentoSede_exists($scope.progettoId, $scope.cndAccreditamentoSede.cndAccreditamentoId, value).then(function (data) {
                //console.info('data', data);
                $scope.existsSede = data;
            });
        }

    }
})();